import React from 'react';
import { animateScroll as scroll } from 'react-scroll';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';

const styles = () => ({
  announcementsButton: {
    display: 'inline-block',
    border: '1px solid #ffca28',
    borderRadius: 21,
    padding: '8px 24px',
    marginBottom: 40,
    color: '#394f5a',
    cursor: 'pointer',
    '& svg': {
      fontSize: 16,
      top: 3,
      position: 'relative',
      marginRight: 4,
      fill: '#ffca28',
    },
  },
});

class AnnouncementButton extends React.Component {
  render() {
    const {
      classes,
      t,
      announcements,
    } = this.props;

    let count = announcements.length;
    announcements.map((announcement) => {
      if (announcement.state === 'dismissed') {
        count--;
      }
    });

    if (count <= 0) {
      return '';
    }

    return (
      <div
        className={`announcements-button ${classes.announcementsButton}`}
        onClick={() => {
          scroll.scrollToBottom();
        }}
      >
        <VolumeUpIcon />
        {' '}
        <b>{count}</b>
        {' '}
        {t('Announcements')}
      </div>
    );
  }
}

export default withStyles(styles)(withTranslation()(AnnouncementButton));
